import { Typography as Text } from '@material-ui/core';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { ActivityItem } from '@spotify/plugin-confidence-activity-react';

import type { Rule } from './types';

export const IdSection = ({
  oldRule,
  newRule,
}: {
  oldRule?: Rule;
  newRule?: Rule;
}) => {
  const oldName = oldRule?.name;
  const newName = newRule?.name;

  const ruleId = extractLastNameComponent(oldName ?? newName)?.slice(-4);

  return (
    <ActivityItem.Section label="ID">
      <Text variant="body1">#{ruleId}</Text>
    </ActivityItem.Section>
  );
};
